import { SHOW_USER_FEEDBACK } from './types'

const showUserFeedback = (msg, type) => ({
  type: SHOW_USER_FEEDBACK,
  payload: { msg, type }
})

export { showUserFeedback }
